<template>
    <div>
        <trial-end-clock
            :title="$t.__('common.labels.account_is_now_inactive')"
            :subtitles="[
                $t.__('common.labels.subscription_expired'),
                $t.__('pages.errors.BasicCartExpired.to_continue_choose_offer'),
            ]"
        >
            <a
                href="javascript:;"
                onclick="MySupport.getForm()"
                class="primary-50-bkg white br fs-4 lh-24 pt-2 pb-2 pl-4 pr-4 semibold"
            >
                {{ $l10n.__('Contacter un commercial') }}
            </a>
            <div class="fs-4 lh-24 semibold mt-4" v-html="tchat"></div>
        </trial-end-clock>
    </div>
</template>

<script>
import TrialEndClock from 'vcomponents/pages/errors/TrialEndClock.vue';

export default {
    components: {
        TrialEndClock,
    },
    props: {},
    computed: {
        tchat: function () {
            return this.$l10n.__(
                'Nous vous invitons à prendre contact avec nos conseillers via le %(startTag)s tchat %(endTag)s',
                {
                    startTag:
                        '<a href="javascript:;" onclick="MySupport.getForm();" class="link fs-4 lh-24 semibold">',
                    endTag: '</a>',
                },
            );
        },
    },
};
</script>
